import { module } from "../modular/modular";
import { body, html } from "../utils/environment";
import { gsap } from "gsap";
import Swup from 'swup';
import SwupParallelPlugin from '@swup/parallel-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupProgressPlugin from '@swup/progress-plugin';

import { getScrollBarWidth } from "../utils/device";

export default class extends module {
	constructor(m) {
		super(m);
	}

	init() {
		this.setSizes();
		this.setTheme(document.querySelector('#swup'));

		// this.load = new modularLoad({
		// 	enterDelay: 1200,
		// 	exitDelay: 2000,
		// });
		
		if(document.querySelectorAll('.js-legal-link').length > 0) {
			if(typeof tarteaucitron === 'undefined') {}
			else {
				tarteaucitron.parameters.readmoreLink = document.querySelectorAll('.js-legal-link')[0].getAttribute('href');
			}
		}

		this.swup = new Swup({
			containers:['#swup'],
			animateHistoryBrowsing: true,
			plugins: [
				new SwupParallelPlugin(), 
				new SwupGtmPlugin(),
				new SwupHeadPlugin(),
				new SwupPreloadPlugin(),
				new SwupProgressPlugin(
					{
						className: 'swup-progress-bar',
						transition: window.isMobile ? 600 : 1200,
						delay: -1,
						initialValue: 0,
						finishAnimation: true
					}
				),
				new SwupScrollPlugin({
					doScrollingRightAway: true,
					animateScroll: {
						betweenPages: true,
						samePageWithHash: true,
						samePage: true
					},
					shouldResetScrollPosition: (link) => false
				})
			]
		});

		this.swup.hooks.on('link:click', () => {			
			html.classList.add('is-loading');
			this.call('removeAllNotifications','Notification');
		}, { priority: -100 });

		this.swup.hooks.on('link:self', () => {
			gsap.delayedCall(0.3,() => {
				html.classList.remove('is-loading');
			});
		});

		this.swup.hooks.on('content:insert', (visit, { containers }) => {
			// console.log('------ content::insert');

			html.classList.add("has-transition");
			html.classList.remove("has-dom-ready");
			html.classList.remove("has-dom-ready-callback");
			html.classList.remove("has-dom-animated");

			for (const { next, remove } of containers) {
				this.call('destroy', remove[0], 'app');

				this.newContainer = next;

				this.newContainer.classList.add('is-next-container-start');
				
				gsap.delayedCall(0.1,() => {
					this.call('update', this.newContainer, 'app');
					this.newContainer.classList.add('is-next-container');
					this.newContainer.classList.remove('is-next-container-start');
				});
			}

		});

		this.swup.hooks.before('content:remove', (visit, { containers }) => {
			// console.log('------ content::remove');
			html.classList.remove('is-loading');

			this.newContainer.classList.remove('is-next-container');
			this.setSizes();
			this.setTheme(this.newContainer);

			html.classList.add("has-transition");
			html.classList.remove("has-dom-ready");
			html.classList.remove("has-dom-ready-callback");
			html.classList.remove("has-dom-animated");
			window.isVisiting = true;

			// Battery saver check blocked video
			this.checkBlockedVideos();

			gsap.delayedCall(window.readyDelay, () => {
				html.classList.add("has-dom-ready");

				this.call('update','Theme');

				Object.entries(this.modules).forEach(([key, module]) => {
					Object.entries(module).forEach(([key, moduleInstance]) => {
						if (typeof moduleInstance.ready == "function") {
							moduleInstance.ready();
						}
					});
				});

				body.setAttribute('data-template',this.newContainer.getAttribute('data-template'));

				gsap.delayedCall(window.readyCallbackDelay, () => {
					html.classList.add("has-dom-ready-callback");
					html.classList.add("has-dom-animated");
					html.classList.remove("has-transition");
				});
			});
		});

		// Manage errors
		this.swup.hooks.on('fetch:error', () => {
			// console.log('--- fetch error ---');
		});

		this.swup.hooks.on('fetch:timeout', () => {
			// console.log('--- fetch timeout ---');
		});

		/**
		 * Overwrite swup's scrollTo function
		 */
		this.swup.scrollTo = (offsetY, animate = true) => {
			if (!animate) {
				this.swup.hooks.callSync('scroll:start', undefined);
				window.scrollTo(0, offsetY);
				this.swup.hooks.callSync('scroll:end', undefined);
				return;
			}
		};

		this.bindResize = this.resize.bind(this);
		window.addEventListener('resize',this.bindResize);

		// first hit data template
		body.setAttribute('data-template',document.querySelector('#swup').getAttribute('data-template'));

		// Battery saver check blocked video
		this.checkBlockedVideos();
	}

	setFirstLoad() {
		
        gsap.delayedCall(window.readyDelay + 0.2, () => {
            html.classList.add("is-ready");
            html.classList.add("has-dom-ready");

            gsap.delayedCall(window.readyCallbackDelay, () => {
                html.classList.add("has-dom-ready-callback");
                html.classList.add("has-dom-animated");

                window.firstHit = false;
            });

            Object.entries(this.modules).forEach(([key, module]) => {
                Object.entries(module).forEach(([key, moduleInstance]) => {
                    if (typeof moduleInstance.ready == "function") {
                        moduleInstance.ready();
                    }
                });
            });
        });
    }

	setSizes() {
		if (getScrollBarWidth() > 0) {
			body.classList.add("has-scrollbar-y");
			document.documentElement.style.setProperty(
				"--scrollbar",
				`${getScrollBarWidth()}px`
			);
		} else {
			body.classList.remove("has-scrollbar-y");

			document.documentElement.style.setProperty(
				"--scrollbar",
				`0px`
			);
		}

		let absRatio = 1;
		if(window.innerWidth < window.innerHeight) {
			absRatio =  window.innerHeight / window.innerWidth;
		} else {
			absRatio =  window.innerWidth / window.innerHeight;
		}

		document.documentElement.style.setProperty(
			"--absRatio",
			`${absRatio}`
		);

		// screen height
		document.documentElement.style.setProperty(
			"--app-availheight",
			`${window.screen.availHeight}px`
		);
		document.documentElement.style.setProperty(
			"--app-height",
			`${window.innerHeight}px`
		);
		document.documentElement.style.setProperty(
			"--app-height-negative",
			`-${window.innerHeight}px`
		);
	}

	setTheme(container) {
		let themeWrapper = container.querySelector('[data-theme-color]');
		let themeColor = '#ffffff';
		
		if(themeWrapper != undefined) {
			themeColor = themeWrapper.getAttribute('data-theme-color');
		}

		let metaThemeColor = document.querySelector('[name=theme-color]');
		metaThemeColor.setAttribute('content',themeColor);

		document.documentElement.style.setProperty(
			"--themeColor",
			`${themeColor}`
		);
	}

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.6, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		this.setSizes();
	}


	checkBlockedVideos() {
		this.bindTouch = this.touch.bind(this);
		body.addEventListener('touchstart',this.bindTouch);

		this.$videos = document.querySelectorAll('video');

		this.$videos.forEach((video) => {
			if(video.getAttribute('autoplay') != null) {
				if(!video.playing) {
					video
					.play()
					.then(() => {})
					.catch((error) => {
						//Do something like adding controls to allow user to manually play
						if (error.name === "NotAllowedError") {
							html.classList.add('has-battery-saver');
						}
					});
				}
			}
		});
	}

	touch() {
		this.$videos = document.querySelectorAll('video');

		this.$videos.forEach((video) => {
			if(video.getAttribute('autoplay') != null) {
				if(!video.playing) {
					video
					.play()
					.then(() => {})
					.catch((error) => {
						
					});

					html.classList.remove('has-battery-saver');
				}
			}
		});
	}
}
